import { TableCollection } from '@react-types/table';
import { useMemo } from 'react';

export default function useIsInfinityScroll(collection: TableCollection<unknown>) {
    return useMemo(() => {
        const bodyProps = collection.body?.props;

        return bodyProps?.loadingState !== undefined && typeof bodyProps?.onLoadMore === 'function';
    }, [collection.body.props]);
}
